import { Bus } from '@rxfx/bus';

export interface CommonEvent {
  name: string;
  payload: any;
}

export interface UserCardCreatedEvent extends CommonEvent {
  name: 'UserCardCreatedEvent';
  payload: {
    userCardId: number;
  };
}

export type AnyEvent = UserCardCreatedEvent;

export function createInstance() {
  return new Bus<AnyEvent>();
}

export type EventBus = ReturnType<typeof createInstance>;
